import { render } from "./add-user-modal.vue?vue&type=template&id=0b248d69"
import script from "./add-user-modal.vue?vue&type=script&lang=js"
export * from "./add-user-modal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/rspack-vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__